import { inject, injectable } from 'inversify';
import HttpClient from 'src/features/http';
import {
  SendSlackMessageRequest,
  SlackApiResponse,
  SlackNotificationsServiceInterface,
} from 'src/features/slack/data/service/SlackNotificationsService.types';
import { SLACK_CHANNEL_WEBHOOKS } from 'src/features/slack/data/service/slackNotificationsService.constants';

@injectable()
class SlackNotificationsService implements SlackNotificationsServiceInterface {
  @inject(HttpClient) private httpClient!: HttpClient;

  async send(params: SendSlackMessageRequest) {
    const bodyParams = new URLSearchParams();
    bodyParams.append('channel', params.channel);

    bodyParams.append('attachments', JSON.stringify(params.attachments));

    return this.httpClient.getClient().post<SlackApiResponse>(
      SLACK_CHANNEL_WEBHOOKS[params.channel],
      // bodyParams,
      JSON.stringify({
        channel: params.channel,
        attachments: [params.attachments],
      }),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
        },
      }
    );
  }
}

export default SlackNotificationsService;
